export const getOfferAppliedAmount = () => sessionStorage.getItem('offerNudgeAmount');
export const setOfferAppliedAmount = (amount: number) => sessionStorage.setItem('offerNudgeAmount', amount.toString());
export const removeOfferAppliedAmount = () => sessionStorage.removeItem('offerNudgeAmount');

const PENDING_L2_GRATIFICATION_KEY = 'offerNudgeL2Gratification';

export type PendingL2Gratification = {
  savedAmount: number;
  appliedCouponsCount: number;
};

export const setPendingL2Gratification = (data: PendingL2Gratification) => {
  sessionStorage.setItem(PENDING_L2_GRATIFICATION_KEY, JSON.stringify(data));
};

export const getPendingL2Gratification = (): PendingL2Gratification | null => {
  try {
    const stored = sessionStorage.getItem(PENDING_L2_GRATIFICATION_KEY);
    if (!stored) return null;
    const parsed = JSON.parse(stored) as PendingL2Gratification;
    if (
      typeof parsed.savedAmount !== 'number' ||
      typeof parsed.appliedCouponsCount !== 'number' ||
      parsed.appliedCouponsCount < 1
    ) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const clearPendingL2Gratification = () => {
  sessionStorage.removeItem(PENDING_L2_GRATIFICATION_KEY);
};

const COUPON_CODE_KEY = 'couponCode';

export const getAppliedCoupons = (): string[] => {
  try {
    const stored = localStorage.getItem(COUPON_CODE_KEY);
    if (!stored) return [];
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : parsed ? [parsed] : [];
  } catch {
    return [];
  }
};

export const getOfferAppliedMessage = (
  appliedCoupons: string[],
  appliedText: string,
  appliedCouponsCount?: number
): string => {
  if (appliedCouponsCount !== undefined && appliedCouponsCount > 0) {
    const couponLabel = appliedCouponsCount === 1 ? 'coupon' : 'coupons';
    return `${appliedCouponsCount} ${couponLabel} ${appliedText}`;
  }

  if (!appliedCoupons.length) return '';

  return `${appliedCoupons.join(', ')} ${appliedText}`;
};

export const addAppliedCoupon = (couponCode: string) => {
  const coupons = getAppliedCoupons();
  if (!coupons.includes(couponCode)) {
    coupons.push(couponCode);
  }
  localStorage.setItem(COUPON_CODE_KEY, JSON.stringify(coupons));
};

export const removeAppliedCoupon = (couponCode: string) => {
  const coupons = getAppliedCoupons().filter((c) => c !== couponCode);
  localStorage.setItem(COUPON_CODE_KEY, JSON.stringify(coupons));
};

export const replaceAppliedCoupons = (couponCodes: string[]) => {
  localStorage.setItem(COUPON_CODE_KEY, JSON.stringify(couponCodes));
};

export const clearAppliedCoupons = () => {
  localStorage.setItem(COUPON_CODE_KEY, JSON.stringify([]));
};